import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import * as E from "./ExtratoStyle";
import Loading from "../Loading/Loader";
import TabelaExtrato from "../Tabelas/TabelaExtrato";
import SideBarBox from "../Sidebar/SideBarBox";
import { usePulse } from "../../context/LoadContext";

// Função para calcular datas (sem alteração)
const getDateRange = (filter) => {
  const now = new Date();
  let startDate = new Date();
  let endDate = new Date();

  switch (filter) {
    case "7 Dias":
      startDate.setDate(now.getDate() - 7);
      break;
    case "15 Dias":
      startDate.setDate(now.getDate() - 15);
      break;
    case "1 Mês":
      startDate.setMonth(now.getMonth() - 1);
      break;
    default:
      startDate = new Date(0); // Desde o Início
      break;
  }

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return { startDate: formatDate(startDate), endDate: formatDate(endDate) };
};

export default function Extrato() {
  const { userData } = useContext(AuthContext); // userData não está sendo usado, mas mantive
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("Desde o Início");
  const {showPulse, hidePulse} = usePulse()

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

//   useEffect(() => {
//     showPulse();
//     setTimeout(() => {
//         hidePulse();
//     }, 500); 
//   }, [filter]); 


  if (error) {
    return (
      <SideBarBox>
        <div>{error}</div>
      </SideBarBox>
    );
  }

  const dateRange = getDateRange(filter);

  return (
    <SideBarBox>
      <E.ExtratoContainer>
        {/* A logo no fundo pode ser opcional ou ajustada para não atrapalhar a leitura */}
        {/* <E.LoginBehind src="logo-golden.png" /> */}

        <E.MainCard>
          <E.Header>
            <E.Title>Extrato da Conta</E.Title>
            <E.Subtitle>Consulte suas movimentações</E.Subtitle>
          </E.Header>

          <E.FilterContainer>
            {["Desde o Início", "7 Dias", "15 Dias", "1 Mês"].map((f) => (
              <E.FilterButton
                key={f}
                onClick={() => handleFilterChange(f)}
                className={filter === f ? "active" : ""}
              >
                {f}
              </E.FilterButton>
            ))}
          </E.FilterContainer>

          <TabelaExtrato
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
          />
        </E.MainCard>
      </E.ExtratoContainer>
    </SideBarBox>
  );
}
